import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { trim } from 'lodash';
const [
  LIST_SALES_ORDER_SHEET,
  LIST_SALES_ORDER_SHEET_SUCCESS,
  LIST_SALES_ORDER_SHEET_FAILURE,
] = createRequestActionTypes('project/LIST_SALES_ORDER_SHEET');

export const listSalesOrderSheet = createAction(
  LIST_SALES_ORDER_SHEET,
  (searchData) => ({ salesType: 'S', searchData }),
);
const listSalesOrderSheetSaga = createRequestSaga(
  LIST_SALES_ORDER_SHEET,
  projectApi.getOrderSheetFiles,
);

const UNLOAD_SALES_ORDER_SHEET = 'project/UNLOAD_SALES_ORDER_SHEET';
export const unloadSalesOrderSheet = createAction(UNLOAD_SALES_ORDER_SHEET);

const SET_SALES_ORDER_SHEET_FITERS = 'project/SET_SALES_ORDER_SHEET_FITERS';
export const setSalesOrderSheetFilters = createAction(
  SET_SALES_ORDER_SHEET_FITERS,
  (filters) => filters,
);

const RESET_SALES_ORDER_SHEET_FILTERS =
  'project/RESET_SALES_ORDER_SHEET_FILTERS';
export const resetSalesOrderSheetFilters = createAction(
  RESET_SALES_ORDER_SHEET_FILTERS,
);

export function* salesOrderSheetSaga() {
  yield takeLatest(LIST_SALES_ORDER_SHEET, listSalesOrderSheetSaga);
}

const initialState = {
  files: null,
  error: null,
  defaultFilters: {
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: null,
    searchEndDt: null,
  },
};

const salesOrderSheet = handleActions(
  {
    [LIST_SALES_ORDER_SHEET_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file, index) => ({
        id: file?.fileUuid,
        fileUuid: file.fileUuid,
        filePartnerNm: file.filePartnerNm,
        filePartnerUuid: file.filePartnerUuid,
        fileNm: trim(file.fileNm),
        fileUrl: file.fileUrl,
        prjNo: file.prjNo,
        prjUuid: file.prjUuid,
        cstNm: file.cstNm,
        fileRegDt: file.fileRegDt,
        fileCrtDt: file.fileCrtDt,
        fileCrtNm: file.fileCrtNm,
      })),

      error: null,
    }),
    [LIST_SALES_ORDER_SHEET_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_SALES_ORDER_SHEET]: () => initialState,
    [RESET_SALES_ORDER_SHEET_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_SALES_ORDER_SHEET_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default salesOrderSheet;
